<template>
    <div class="offerAffirm ben-fff-bg ben-align-center">
        <div class="iffer-icon">
            <img src="./../../../assets/seccess.png" alt="" srcset="">
        </div>
        <p class="text-seccess ben-size-18 ben-text-bold">发送成功</p>
        <p class="text-center ben-size-14 ben-000-color">您的报价已发送成功<br>请耐心等待买家回馈</p>
        <button class="ben-btn-w ben-c41335-color ben-size-14" @click="gotoOfferList">查看报价列表</button>
    </div>
</template>
<script>
export default {
    name:'offerAffirm',
    props: {
        data : {
            type:Object
        }
    },
    data () {
        return {
        digitNum : '',
        digitcomm : "",
            autosize : {
                maxHeight: 50, minHeight: 30
            }
        }
    },
    created () {
        
    },
    methods: {
        
        gotoOfferList(){
            this.$router.replace({
                path: 'offerList'
              })
        }
    },
    mounted () {
        
    },
}

</script>


<style lang='scss' scoped>
.offerAffirm{
    border-radius: 4px;
    width: 300px;
    .van-cell{
        padding: 0;
    }
    .ben-btn-w {
        width: 110px;
        margin-bottom: 40px;
    }
    .text-seccess{
        color: #4BAE4F;
        margin: 15px 0;
    }
    .text-center{
        line-height: 25px;
        margin-bottom: 25px;
    }
    .iffer-icon{
        margin-top: 30px;
        >img{
            width: 50px;
            height: 50px;

        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/procurement/components/offerAffirmed.vue